(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tcc-christmas-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fit() {
    document.querySelectorAll('.tcc-xmas').forEach(function (el) {
      var top = el.getBoundingClientRect().top + window.scrollY;
      el.style.setProperty('--tcc-head', Math.min(top, 500) + 'px');
    });
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  document.addEventListener('shopify:section:load', fit);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-cup-day-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fit() {
    document.querySelectorAll('.tcc-cup').forEach(function (el) {
      var top = el.getBoundingClientRect().top + window.scrollY;
      el.style.setProperty('--tcc-head', Math.min(top, 500) + 'px');
    });
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  document.addEventListener('shopify:section:load', fit);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-split-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fit() {
    document.querySelectorAll('.tcc-split').forEach(function (el) {
      var top = el.getBoundingClientRect().top + window.scrollY;
      el.style.setProperty('--tcc-head', Math.min(top, 500) + 'px');
    });
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  document.addEventListener('shopify:section:load', fit);
})();

  } catch(e) { console.error(e); }
})();
})();
